// extracted by mini-css-extract-plugin
export default {"list":"CreateOrganizationArtistsRow_list__UWUrU"};